/**
 * Convertit une date (Date, string ou timestamp) en ISO `YYYY-MM-DD`.
 * @param {Date | string | number | null | undefined} value
 * @returns {string | null}
 */
export const toIsoDate = (value) => {
  if (!value) return null;
  if (value instanceof Date && !Number.isNaN(value.getTime())) {
    const year = value.getFullYear();
    const month = String(value.getMonth() + 1).padStart(2, "0");
    const day = String(value.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  }
  if (typeof value === "string" && /^\d{4}-\d{2}-\d{2}$/.test(value)) {
    return value;
  }
  const parsed = new Date(value);
  if (Number.isNaN(parsed.getTime())) return null;
  const year = parsed.getFullYear();
  const month = String(parsed.getMonth() + 1).padStart(2, "0");
  const day = String(parsed.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

/**
 * Vérifie si une date ISO est comprise dans un intervalle (inclus).
 * @param {string} targetIso
 * @param {string} startIso
 * @param {string} endIso
 * @returns {boolean}
 */
export const isDateInRange = (targetIso, startIso, endIso) => {
  if (!targetIso || !startIso || !endIso) return false;
  const target = new Date(targetIso);
  const start = new Date(startIso);
  const end = new Date(endIso);
  if (
    Number.isNaN(target.getTime()) ||
    Number.isNaN(start.getTime()) ||
    Number.isNaN(end.getTime())
  ) {
    return false;
  }
  return target >= start && target <= end;
};

/**
 * Formate une date ISO en label court FR (ex: "02 févr.").
 * @param {string} isoDate
 * @returns {string}
 */
export const formatDateFR = (isoDate) => {
  if (!isoDate) return "";
  const dateObj = new Date(isoDate);
  if (Number.isNaN(dateObj.getTime())) return "";
  return dateObj.toLocaleDateString("fr-FR", {
    day: "2-digit",
    month: "short",
  });
};
